import React from 'react';
import { Loader as ZenitLoader } from '@uberall/zenit';

import styles from './loader.module.css';

const Loader = () => {
    return (
        <span aria-label="loading">
            <ZenitLoader className={styles.container} />
        </span>
    );
};

export default Loader;
